import jsPDF from "jspdf";

import "jspdf-autotable";
import accounting from "accounting";
const generateAndDownloadReceipt = (
  amount,
  payment_id,
  currency,
  plan,
  email,
  phone,
  id,
  method,
  create_at
) => {
  const doc = new jsPDF("l", "mm", [200, 170]);

  // Set up your receipt details
  const transactionDate =
    create_at > 0
      ? new Date(create_at * 1000).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : new Date().toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

  // Set document properties
  doc.setFontSize(12); // Set fill color for the first rectangle (green)

  doc.setDrawColor(0); // Draw the first rectangle
  doc.setFillColor(0, 255, 255);
  doc.rect(0, 6, 50, 6, "F");

  doc.setDrawColor(0);
  doc.setFillColor(0, 33, 71);
  doc.rect(50, 6, doc.internal.pageSize.width - 50, 6, "F");

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(25);
  doc.text("Jaano.AI", doc.internal.pageSize.width / 2, 30, {
    align: "center",
  });

  doc.setLineWidth(1);
  doc.line(10, 40, doc.internal.pageSize.width - 10, 40);

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");
  doc.text("Token AI Labs Private Limited", 20, 50);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "415, Krushal Commercial Complex, G. M. Road, Chembur, Mumbai, India 400089,",
    20,
    55
  );
  doc.text("E-mail: support@tokenailabs.com", 20, 60);

  doc.setLineWidth(0.5);
  doc.line(10, 65, doc.internal.pageSize.width - 10, 65);
  doc.setFontSize(16);
  doc.setFont("Helvetica", "bold");
  doc.text("RECEIPT", doc.internal.pageSize.width / 2, 75, {
    align: "center",
  });
  doc.line(10, 80, doc.internal.pageSize.width - 10, 80);

  doc.setFontSize(12);
  doc.setLineWidth(0.1);

  doc.setFont("Helvetica", "normal");
  doc.text(`Receipt id:`, 20, 87);
  doc.setFont("Helvetica", "bold");
  doc.text(`${id?.split("_")[1]} `, 50, 87);
  doc.setFont("Helvetica", "normal");
  doc.text(`Date:`, 130, 87);
  doc.setFont("Helvetica", "bold");
  doc.text(`${transactionDate} `, 140, 87);
  doc.line(10, 90, doc.internal.pageSize.width - 10, 90);

  doc.setFont("Helvetica", "normal");
  doc.text(`Transaction ID:`, 20, 97);
  doc.setFont("Helvetica", "bold");
  doc.text(`${payment_id}`, 50, 97);
  doc.line(10, 100, doc.internal.pageSize.width - 10, 100);

  doc.setFont("Helvetica", "normal");
  doc.text(`email: `, 20, 107);
  doc.setFont("Helvetica", "bold");
  doc.text(`${email} `, 50, 107);
  doc.line(10, 110, doc.internal.pageSize.width - 10, 110);

  doc.setFont("Helvetica", "normal");
  doc.text(`Phone:`, 20, 117);
  doc.setFont("Helvetica", "bold");
  doc.text(`${phone}`, 50, 117);
  doc.line(10, 120, doc.internal.pageSize.width - 10, 120);

  doc.setFont("Helvetica", "normal");
  doc.text(`Plan:`, 20, 127);
  doc.setFont("Helvetica", "bold");
  doc.text(` ${plan} plan`, 50, 127);
  doc.line(10, 130, doc.internal.pageSize.width - 10, 130);

  doc.setFont("Helvetica", "normal");
  doc.text(`Plan Price:`, 20, 137);
  doc.setFont("Helvetica", "bold");
  doc.text(`${currency} ${accounting.formatNumber(amount)}`, 50, 137);
  doc.line(10, 140, doc.internal.pageSize.width - 10, 140);

  doc.setFont("Helvetica", "normal");
  doc.text(`Method:`, 20, 147);
  doc.setFont("Helvetica", "bold");
  doc.text(`${method} `, 50, 147);
  doc.line(10, 150, doc.internal.pageSize.width - 10, 150);

  doc.setFontSize(8);
  doc.setFont("Helvetica", "normal");
  doc.text(
    `This is computer generated receipt. No signature is required.`,
    20,
    157
  );

  doc.setDrawColor(0);
  doc.setFillColor(15, 23, 22);
  doc.rect(0, 164, doc.internal.pageSize.width, 10, "F");

  // Generate the PDF and initiate download
  doc.save(`receipt_${payment_id}.pdf`);
};

export default generateAndDownloadReceipt;
